import { DoorOpen, DoorClosed, UtensilsCrossed, Beer, ShieldCheck, Presentation, Toilet, Info, type LucideIcon } from "lucide-react";
import type { SeatingElementType } from "@/lib/types";

export type ElementPreset = {
  label: string;
  icon: LucideIcon;
  color: string;
  defaultW: number;
  defaultH: number;
};

export const ELEMENT_PRESETS: Record<SeatingElementType, ElementPreset> = {
  entrance: { label: "Eingang", icon: DoorOpen, color: "#22c55e", defaultW: 2, defaultH: 1 },
  exit: { label: "Ausgang", icon: DoorClosed, color: "#ef4444", defaultW: 2, defaultH: 1 },
  catering: { label: "Catering", icon: UtensilsCrossed, color: "#f59e0b", defaultW: 6, defaultH: 2 },
  bar: { label: "Bar", icon: Beer, color: "#d97706", defaultW: 4, defaultH: 2 },
  orga: { label: "Orga", icon: ShieldCheck, color: "#6366f1", defaultW: 3, defaultH: 2 },
  stage: { label: "Bühne", icon: Presentation, color: "#3b82f6", defaultW: 6, defaultH: 2 },
  wc: { label: "WC", icon: Toilet, color: "#0ea5e9", defaultW: 2, defaultH: 2 },
  custom: { label: "Info", icon: Info, color: "#64748b", defaultW: 3, defaultH: 2 },
};

export function getElementPreset(type: string): ElementPreset {
  return ELEMENT_PRESETS[type as SeatingElementType] ?? ELEMENT_PRESETS.custom;
}
